<template>
  <div class="legend-item-wrapper">
    <map-icon :icon="iconUrl" :color="category.color" />
    <div class="legend-label">{{ categoryName }}</div>
  </div>
</template>

<style scoped>
  .legend-item-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .legend-label {
    padding-left: 8px;
    margin-top: 8px;
    margin-right: 16px;
  }

  .legend-icon {
    width: 38px;
    height: 38px;
    margin-right: 8px;
  }

</style>

<script>
import { mapState } from 'vuex';
import { CategoryType } from '@/types';
import MapIcon from './MapIcon.vue';

export default {
  name: 'map-legend-item',
  computed: {
    ...mapState({
      locale: (state) => state.config.locale,
    }),
    categoryName() {
      // eslint-disable-next-line
      const l10n = this.category.categoryL10n.find((categoryL10n) => categoryL10n.languageCode === this.locale);
      return l10n ? l10n.name : this.category.name;
    },
    iconUrl() {
      const SVG_ICON_INDEX = 5;
      return this.category.icon[SVG_ICON_INDEX].url;
    },
  },
  props: {
    category: {
      type: CategoryType,
      required: true,
    },
  },
  components: {
    MapIcon,
  },
};
</script>
